module.exports = __webpack_public_path__ + "static/media/panorama-360-nordic-style-living-room-dining-room-10-3d-model-max.f1afd765.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/panorama-360-nordic-style-living-room-dining-room-10-3d-model-max.jpg
// module id = 567
// module chunks = 0